<template>
  <div class="container">
    <div class="banner">
      <img :src="reRecruitProject.webProjectPic" alt="" />
    </div>
    <!-- 搜索 -->
    <div
      ref="searchBar"
      :class="{ fixedTop: searchBarFixedTop }"
      class="search-wrapper"
    >
      <input-search
        :size="searchBarFixedTop ? 'small' : 'medium'"
        placeholder="搜索公司/职位"
        v-model="searchKeyword"
      ></input-search>
    </div>

    <div class="navigation">
      <!-- <div data-v-2a813751="" class="content-title">
          <div data-v-2a813751="" class="name">
            {{ reRecruitProject.projectName }}
          </div>
          <div data-v-2a813751="" class="hdmItem">
            共{{ reRecruitProject.count }}个岗位
          </div>
        </div> -->
      <ul class="job-tab">
        <li
          v-for="(item, index) in tabList"
          :key="index"
          class="tab-item"
          :class="{ 'item--active': index === tabCur }"
          @click="tabSelect(item.id)"
        >
          {{ item.title }}
          <span v-if="index == '1'">({{ reRecruitProject.count }})</span>
        </li>
      </ul>
    </div>

    <div class="main clearfix">
      <div
        class="content"
        v-loading:#ffffff7d.scrollFixed="loading"
        v-if="tabCur == '0'"
      >
        <ul class="content-list">
          <li
            class="recommend-company-item"
            v-for="(item, index) in companyList"
            :key="index"
          >
            <!-- <router-link :to="'/companyDetail/' + item.reCompanyId"> -->
            <a :href="'/companyDetail/' + item.reCompanyId" target="_blank">
              <div class="company-top-container">
                <div class="company-top">
                  {{ item.reCompanyName }}
                </div>
                <div class="company-bottom substring">
                  <span class="tag" v-if="item.industry">{{
                    item.industry
                  }}</span
                  ><span class="tag" v-if="item.enterpriseNature">{{
                    item.enterpriseNature
                  }}</span
                  ><span class="tag" v-if="item.enterpriseScale">{{
                    item.enterpriseScale
                  }}</span>
                  <span class="tag" v-if="item.groupName">{{
                    item.groupName
                  }}</span>
                </div>
              </div>
            </a>
            <!-- </router-link> -->
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="companyForm.pageNum"
            :limit.sync="companyForm.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <div
        class="content"
        v-loading:#ffffff7d.scrollFixed="loading"
        v-else-if="tabCur == '1'"
      >
        <ul class="content-list">
          <li
            class="recommend-job-item"
            v-for="(item, index) in jobsList"
            :key="index"
          >
            <a :href="'/jobDetail/' + item.jobId" target="_blank">
              <!-- <router-link :to="'/jobDetail/' + item.jobId"> -->
              <div class="job-top-container">
                <div class="job-top">
                  <div class="job-name">{{ item.job }}</div>
                  <div class="wage">{{ item.startSalary }}</div>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
              </div>
              <!-- </router-link> -->
            </a>
            <div class="company-bottom">
              <div class="company-desc">
                <a :href="'/companyDetail/' + item.companyId" target="_blank">
                  <!-- <router-link :to="'/companyDetail/' + item.companyId"> -->
                  <div class="company-name substring">
                    {{ item.companyName }}
                  </div>
                  <!-- </router-link> -->
                </a>
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="jobForm.pageNum"
            :limit.sync="jobForm.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getOffsetTop } from "@/helper/utilities";
let positionY = 0;
let searchBarClientHeight = 0;
import {
  getJobsList,
  getProjectCompanyList,
  getSingleRecruitProject,
  getPreviewUrl,
} from "@/api/index";
import { encryptSm4, decryptSm4 } from "@/helper/sm4";
export default {
  name: "zoneDetails",
  data() {
    return {
      reRecruitProject: "",
      tabCur: 0, // 当前tabs下标
      tabList: [
        {
          id: 0,
          title: "按企业",
        },
        {
          id: 1,
          title: "按岗位",
        },
      ],
      // 查询参数
      searchKeyword: "",
      currentPage: 1,
      total: 0,
      searchBarFixedTop: false,
      loading: false,
      jobsList: [],
      companyList: [],
      companyForm: {
        pageNum: 1,
        pageSize: 10,
        reCompanyNameLike: "",
        reRecruitProjectId: "",
      },
      jobForm: {
        pageNum: 1,
        pageSize: 10,
        search: "",
        reRecruitProjectId: "",
      },
    };
  },
  watch: {
    searchKeyword(newVal, oldVal) {
      this.searchBarFixedTop && window.scrollTo(0, positionY);
      this.getList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      positionY = getOffsetTop(document.body, this.$refs.searchBar);
      searchBarClientHeight = this.$refs.searchBar.clientHeight;
    });
    const onPageScroll = () => {
      const top = this.$refs.searchBar.getBoundingClientRect().top;
      this.searchBarFixedTop =
        window.scrollY > positionY - searchBarClientHeight / 2;
    };
    window.addEventListener("scroll", onPageScroll);

    this.$on("hook:destroyed", () => {
      window.removeEventListener("scroll", onPageScroll);
    });
  },
  created() {
    this.reRecruitProjectId = this.$route.query.id;
    this.title = this.$route.query.title;
    this.SingleRecruitProject(this.reRecruitProjectId);
    this.getList();
  },
  methods: {
    //获取项目详情
    SingleRecruitProject(reRecruitProjectId) {
      getSingleRecruitProject(reRecruitProjectId).then((res) => {
        if (res.code == 200) {
          this.PreviewUrl(res.data);
        }
      });
    },

    PreviewUrl(item) {
      getPreviewUrl(encryptSm4(item.webProjectPic)).then((response) => {
        item.webProjectPic = decryptSm4(response.msg);
        this.reRecruitProject = item;
      });
    },

    tabSelect(index) {
      this.tabCur = index;
      this.searchKeyword = null;
      this.getList();
    },

    getList() {
      const loading = this.$loading();
      if (this.tabCur == "0") {
        (this.companyForm.reCompanyNameLike = this.searchKeyword),
          (this.companyForm.reRecruitProjectId = this.reRecruitProjectId),
          getProjectCompanyList(this.companyForm)
            .then((res) => {
              if (res.code == 200) {
                loading.close();
                this.companyList = res.data; //追加新数据
                this.total = res.total;
              }
            })
            .catch(() => {
              loading.close();
            });
      } else if (this.tabCur == "1") {
        this.jobForm.search = this.searchKeyword;
        this.jobForm.reRecruitProjectId = this.reRecruitProjectId;
        getJobsList(this.jobForm)
          .then((res) => {
            loading.close();
            this.jobsList = res.data;
            this.total = res.total;
          })
          .catch(() => {
            loading.close();
          });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  display: flex;
  flex-direction: column;
  min-width: @main-width;
  min-height: 350px;
  img {
    width: 100%;
    max-height: 500px;
  }
}

.search-wrapper {
  // position: absolute;
  width: 100%;
  // padding: 0 200px;
  // transform: translateY(-50%);
  margin-top: -25px;
  z-index: 100;
  &.fixedTop {
    position: fixed;
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0.1);
    top: 25px;
    padding: 20px 130px;
    z-index: 1000;
    background-color: #fff;
    transform: translateY(0);
  }
}

.navigation {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: -200px;
  z-index: 1;

  .content-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    width: @main-width;
    margin: 0 auto;
    .name {
      white-space: pre-wrap;
      text-align: center;
      margin-bottom: 10px;
      font-weight: 600;
      font-size: 30px;
      color: rgb(51, 51, 51);
      line-height: 40px;
      position: relative;
      font-style: normal;
    }
    .hdmItem {
      font-size: 20px;
    }
  }
  .job-tab {
    -ms-flex-align: center;
    -ms-flex-pack: center;
    align-items: center;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    height: 60px;
    justify-content: center;
    line-height: 60px;
    margin-bottom: 20px;
    margin-top: 1%;
    text-align: center;
    .tab-item {
      color: #333;
      font-size: 22px;
      margin: 0 40px;
      width: 128px;
      position: relative;
    }
    .tab-item.item--active {
      color: #00a0e9;
    }
    .tab-item.item--active:after {
      background: #00a0e9;
      bottom: 0;
      content: "";
      height: 4px;
      left: calc(50% - 10px);
      position: absolute;
      width: 20px;
    }
  }
}

.main {
  width: @main-width;
  margin: 0 auto;
  .content-list {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .recommend-company-item:nth-child(2n) {
      margin-right: 0;
    }
    .recommend-company-item {
      background-color: #fff;
      box-shadow: 0px 9px 20px 0px #c2c1c180;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      margin-bottom: 21px;
      margin-right: 20px;
      padding: 13px 27px;
      width: 45%;
    }

    .company-top-container {
      line-height: 30px;
    }

    .substring {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      text-align: left;
    }
    .tag {
      font-size: 14px;
    }
    .tag:not(:first-child):before {
      content: "|";
      margin: 0 4px;
    }
  }
  .content-list {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    .recommend-job-item:nth-child(2n) {
      margin-right: 0;
    }
    .recommend-job-item {
      background-color: #fff;
      box-shadow: 0px 9px 20px 0px #c2c1c180;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      margin-bottom: 21px;
      margin-right: 20px;
      padding: 13px 27px;
      width: 45%;
    }

    .job-top-container {
      border-bottom: 1px dotted #666;
      line-height: 30px;
      padding-bottom: 10px;
      .job-top {
        -ms-flex-align: center;
        -ms-flex-pack: justify;
        align-items: center;
        display: -ms-flexbox;
        display: flex;
        justify-content: space-between;
        .job-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .wage {
          flex: 1;
          justify-content: flex-end;
          display: flex;
          color: #d9011e;
          font-size: 16px;
          align-items: center;
          white-space: nowrap;
        }
      }
    }

    .substring {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      text-align: left;
    }
    .tag {
      font-size: 14px;
    }
    .tag:not(:first-child):before {
      content: "|";
      margin: 0 4px;
    }
    .company-bottom {
      -ms-flex-align: center;
      align-items: center;
      display: -ms-flexbox;
      display: flex;
      margin-top: 5px;
      .company-logo-box {
        height: 50px;
        margin-right: 20px;
        margin-top: 10px;
        -o-object-fit: contain;
        object-fit: contain;
        width: 50px;
      }
      img {
        border-style: none;
        vertical-align: middle;
      }
      .company-desc .company-tag {
        margin-top: 10px;
        width: 303px;
      }
    }
  }
  .pagination-wrapper {
    text-align: center;
  }
}
</style>